import React from "react";
import PropTypes from "prop-types";
import { Flex, Text } from "@badi/badi-components";
import { translate } from "base/shared/Localization";
import Image from "components/Image";
import { Root } from "./styled-components";

const MenuElement = ({
  action: { key, icon = "", text },
  actionFunction,
  dataQa = null,
}) => {
  const handleClick = () => {
    actionFunction[key]();
  };

  return (
    <Root data-qa={dataQa && `${dataQa}-menu-element`} onClick={handleClick}>
      <Flex alignItems="center" gutter={1}>
        {icon && <Image src={icon} styles={{ display: "block" }} />}
        <Text body="12-Bold" inline={true}>
          {translate(text)}
        </Text>
      </Flex>
    </Root>
  );
};

MenuElement.propTypes = {
  action: PropTypes.shape({
    key: PropTypes.string.isRequired,
    icon: PropTypes.string,
    text: PropTypes.string,
  }).isRequired,
  actionFunction: PropTypes.shape({
    unpublish: PropTypes.func,
    share: PropTypes.func,
    publish: PropTypes.func,
    preview: PropTypes.func,
    edit: PropTypes.func,
    delete: PropTypes.func,
    seeBooking: PropTypes.func,
    markAsRented: PropTypes.func,
    viewSeekerProfile: PropTypes.func,
    seeMore: PropTypes.func,
  }).isRequired,
  dataQa: PropTypes.string,
};

export default MenuElement;
